module.exports = __webpack_public_path__ + "img/Rectangle 5.abf63679.png";